import axios from "@/plugins/http.service.js";
export default {
    getStat(){
        return axios.post("api/web/country/get-admin-countries-stat")
    },batchAddRows(records){
        return axios.post("api/web/country/batch-add-countries",{records:records})
    },
}

